import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IPublicRating } from '../../models/rating.model';

@Injectable()
export class PublicRatingProvider extends Provider<IPublicRating> {
	protected readonly url: string = '/ratings/public';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public createRatingForScore(reservationExternalId: string, rating: IPublicRating): Promise<void> {
		return this.process(
			this.api.post(`${this.url}/reservation/${reservationExternalId}/score`, rating, true),
			false
		) as unknown as Promise<void>;
	}

	public createOrUpdateRating(reservationExternalId: string, rating: IPublicRating): Promise<void> {
		return this.process(
			this.api.post(`${this.url}/reservation/${reservationExternalId}`, rating)
		) as unknown as Promise<void>;
	}
}
